export default "__VITE_ASSET__DltlmvCR__"